import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getEWDetails, getEWID, getNextPage, getPaymentButtonText } from '../state/selectors';
import { ContentProps, EffectiveWarningProps } from '../state/propTypes';
import { IBActions, NextStep } from '../utils/constants';
import PageNavigation from '../../sharedComponents/PageNavigation/PageNavigation';
import PaymentDetails from './PaymentDetails';
import ewContent from '../utils/content';
import { goToPage, pages } from '../../states/page/actions';
import withContent from '../../containers/withContent';

const mapState = (state) => ({
	effectiveWarning: getEWDetails(state),
	effectiveWarningId: getEWID(state),
	paymentButtonText: getPaymentButtonText(state),
	nextPage: getNextPage(state),
});

const mapDispatch = (dispatch) => ({
	navigateToNextPage: (page) => dispatch(goToPage(page)),
});
export class Review extends Component {
	constructor(props) {
		super(props);

		this.getContinueButtonText = this.getContinueButtonText.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

	componentDidMount() {
		this.props.onAction(IBActions.ON_REVIEW, { val: true, page: 'ewReview' });
	}

	getContinueButtonText() {
		const { content, nextPage, paymentButtonText } = this.props;
		const continueToPayment = !nextPage || nextPage === NextStep.CONTINUE_TO_PAYMENT;
		return continueToPayment ? paymentButtonText : content.continueText;
	}

	handleCancel(event) {
		event.preventDefault();
		this.props.navigateToNextPage(pages.EffectiveWarning.paymentCancelled);
	}

	render() {
		const { content, effectiveWarning, effectiveWarningId, onContinue } = this.props;

		return (
			<div id="reviewPage" data-ewId={effectiveWarningId}>
				<PaymentDetails content={content} effectiveWarning={effectiveWarning} />
				<PageNavigation
					handleContinue={onContinue}
					handleBack={this.handleCancel}
					showContinue
					enableContinue
					enableBack
					showBack
					continueButtonText={this.getContinueButtonText()}
					secondaryButtonText={content.cancelPaymentText}
				/>
			</div>
		);
	}
}

Review.propTypes = {
	content: PropTypes.shape(ContentProps).isRequired,
	effectiveWarning: PropTypes.shape(EffectiveWarningProps),
	effectiveWarningId: PropTypes.string,
	paymentButtonText: PropTypes.string.isRequired,
	nextPage: PropTypes.string,
	navigateToNextPage: PropTypes.func.isRequired,
	onAction: PropTypes.func.isRequired,
	onContinue: PropTypes.func.isRequired,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: ewContent }))(Review);
